// 子仓库 - 线下退费
import to from 'await-to-js';
import * as apis from "@/api/interface/offlineRefund";
// import { CODES } from "@/api/base/codes";

export default {
  namespaced: true,
  state: () => ({
  }),
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
    // 获取银行开户行选项列表
    async getBankNameOptions(ctx, payload = {}) {
      const [, res] = await to(apis.getBankNameOptions(payload));
      return res;
    },
    // 获取用户信息
    async getUserInfo(ctx, payload = {}) {
      const [, res] = await to(apis.getUserInfo(payload));
      return res;
    },
    // 完善用户信息
    async saveUserInfo(ctx, payload = {}) {
      const [, res] = await to(apis.saveUserInfo(payload));
      return res;
    },
    // 线下退费-飞书审批确认
    async submitFeishuApproval(_ctx, payload = {}) {
      const [, res] = await to(apis.submitFeishuApproval(payload));
      return res;
    },
    // 上传申请书
    async contractUpload(_ctx, payload = {}) {
      const [, res] = await to(apis.contractUpload(payload));
      return res;
    },
  },
  modules: {},
};
